import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sentiment-details-key-metrics',
  standalone: false,
  templateUrl: './details-key-metrics.component.html',
  styleUrls: ['./details-key-metrics.component.scss'],
})
export class SentimentDetailsKeyMetricsComponent {
  /** Total actionable feedback */
  @Input() actionableFeedback = 0;
  /** Positive actionable count */
  @Input() positiveActionable = 0;
  /** Neutral actionable count */
  @Input() neutralActionable = 0;
  /** Negative actionable count */
  @Input() negativeActionable = 0;
}
